import React, { useState, useContext } from 'react';
import ProfileSection from '../../Header/ProfileSection';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import { RenderIcon as Icon } from '../../../../utils/icons';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { Divider, IconButton } from '@mui/material';
import { Context } from '../../../../context/context';
import { Link } from 'react-router-dom';
import { EncodeToBase64 } from '../../../../helpers/tools';

import './mobileNavBar.scss';
export const MobileNavBar = ({
    options
}) => {
    const [selectedMenuOption, setSelectedMenuOption] = useState(null);
    const [context, setContext] = useContext(Context);

    const handleGoBack = () =>
        selectedMenuOption
            ? handleClose('slide-left-modal 0.25s', 'options-container', () => setSelectedMenuOption(null))
            : handleClose('slide-down-modal 0.2s', 'mobile-modal');

    const handleClose = (
        animation,
        animationElement,
        onClose = () => setContext(!context),
    ) => {
        const element = document.getElementById(animationElement);
        if (element) {
            element.style.animation = animation || '';
            setTimeout(() => {
                onClose();
            }, 100);
        }
    }

    return (
        <div id='mobile-modal' className='mobile-nav-bar'>
            <div className="menu-header">
                <IconButton onClick={handleGoBack}>
                    <ArrowBackIosRoundedIcon className='arrow-back' />
                </IconButton>
                <span className='menu-header-title'>{selectedMenuOption?.descripcion || 'Menú'}</span>
                <ProfileSection />
            </div>
            <div className='options-container' id='options-container'>
                {!selectedMenuOption && options?.map(menuItem => (
                    <div
                        key={menuItem?.idArea}
                        className='menu-option'
                        onClick={() => handleClose('slide-right-modal 0.25s', 'options-container', () => setSelectedMenuOption(menuItem))} aria-hidden='true'
                    >
                        <div className='option-row'>
                            <Icon index={menuItem?.idArea} className='menu-icon' />
                            <span className='menu-label'>{menuItem?.descripcion}</span>
                        </div>
                        <ArrowForwardIosSharpIcon className='arrow-forward' />
                    </div>
                ))}
                {selectedMenuOption && selectedMenuOption?.aplicaciones?.map(app => {
                    const { url } = app;
                    const routeToNavigate = app?.iframe ? '/menu/' + EncodeToBase64(url) : url;
                    return (
                        <>
                            <Link
                                key={app?.url}
                                className='app-link'
                                onClick={() => handleClose(undefined, 'mobile-modal')}
                                to={routeToNavigate}
                            >
                                <div className='app-option-container'>
                                    {app.descripcion}
                                </div>
                            </Link >
                            <Divider />
                        </>
                    )
                })}
            </div>
        </div >
    )
}